import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberWidgetComponent } from './number-widget.component';



@NgModule({
  declarations: [NumberWidgetComponent],
  imports: [
    CommonModule
  ],
  exports: [NumberWidgetComponent]
})
export class NumberWidgetModule { }
